export interface PopularProps {}

export const usePopular = (props: PopularProps) => {
  return {
    ...props,
  }
}
